import EventTableHelper from './event-table-helper';
import EventUsersTableHelper from './event-users-table-helper';
import EventAttachmentsTableHelper from './event-attachments-table-helper';
import EventCheckInLogsTableHelper from './event-check-in-logs-table-helper';
import EventAttendanceShiftsTableHelper from './event-attendance-shifts-table-helper';
import EventAttendanceDailySummaryTableHelper from './event-attendance-daily-summary-table-helper';


const EventHelpers = {
    TableMain: EventTableHelper,
    TableUsers: EventUsersTableHelper,
    TableAttachments: EventAttachmentsTableHelper,
    TableCheckInLogs: EventCheckInLogsTableHelper,
    TableAttendanceShifts: EventAttendanceShiftsTableHelper,
    TableAttendanceDailySummary: EventAttendanceDailySummaryTableHelper,
}

export default EventHelpers;
